// Chat configuration
export const chatConfig = {
  pageSize: (() => {
    const n = Number(import.meta.env.VITE_CHAT_PAGE_SIZE);
    return Number.isFinite(n) && n > 0 && Number.isInteger(n) ? n : 50;
  })(),
};
